interface GetMicrosoftAuthTokensResult {
    customToken: string | null;
}

/**
 * Retrieves Microsoft auth tokens from localStorage (primary)
 */
export function getMicrosoftAuthTokens(): GetMicrosoftAuthTokensResult {
    const customToken = localStorage.getItem("microsoft_auth_custom_token");

    if (customToken) {
        localStorage.removeItem("microsoft_auth_custom_token");
    }

    return { customToken };
}

